import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Inject,
  Injector,
  INJECTOR,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-select' },
  selector: 'pulse-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements ControlValueAccessor, AfterViewInit {
  itemsLabel = '';
  control = new FormControl();
  @Input() propId = 'i';
  @Input() appearance: any = "outline";
  @Input() floatLabel:any = 'auto';
  @Input() placeholder = '';

  @Input() items: any[] = [
    { id: 1, name: 'option 1' },
    { id: 2, name: 'option 2' },
  ];
  @Input() label: string;
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Input() value: any;

  @Output() selectionChange: EventEmitter<MatSelectChange> =
    new EventEmitter<MatSelectChange>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() pulseDisabledState: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @ViewChild(MatSelect) matSelect: MatSelect;
  constructor(
    protected el: ElementRef,
    @Inject(INJECTOR) private injector: Injector,
    protected cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.selectLabel();
    this.cd.detectChanges();
  }

  selectionChanged(event: MatSelectChange) {
    this.selectionChange.emit(new MatSelectChange(this.matSelect, event.value));
    this.valueChange.emit(event.value);
    this.onChange(event.value);
    this.onTouched();
  }

  selectLabel() {
    this.itemsLabel = '';
    if (this.control.value !== null) {
      if (!this.multiple) {
        this.itemsLabel = this.control.value[this.propId];
      } else {
        if (this.control.value) {
          this.control.value.map((item: any, index: number) => {
            this.itemsLabel =
              index >= 1
                ? this.itemsLabel + ', ' + item[this.propId]
                : this.itemsLabel + item[this.propId];
          });
        }
      }
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: (value: string) => void) {
    if (this.control) {
      this.control.valueChanges.subscribe(fn);
    }
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if (obj) {
      this.control.setValue(obj);
    } else {
      this.control.setValue([]);
    }
    this.cd.detectChanges();
  }

  @HostListener('pulseDisabledState', ['$event'])
  handleDisabledStateEvent(value: boolean) {
    if (this.disabled !== value) {
      this.disabled = value;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.nativeInput) {
      this.nativeInput.disabled = isDisabled;
    }

    this.pulseDisabledState.emit(isDisabled);
  }

  get nativeInput(): HTMLInputElement {
    return this.el.nativeElement.querySelector('input');
  }
}
